(() => {
  if (window.bbCrossUpsellLoaded) return;
  window.bbCrossUpsellLoaded = true;
  const pickupLocation = new URL(window.location.href).searchParams.get('bb_pickup_location');

  const eligibleAtPickup = async (card, match) => {
    if (!window.BbZapiet) return false;
    const shop = card.dataset.bbCrossShop;
    const tree = { product_id: Number(card.dataset.bbCrossProductId), variant_id: Number(match.dataset.treeId) };
    const cross = { product_id: Number(card.dataset.bbCrossAddonId), variant_id: Number(match.dataset.crossId) };
    const matches = await window.BbZapiet.matchingLocations(shop, [tree, cross]);
    const location = pickupLocation
      ? matches.find((item) => String(item.id) === pickupLocation)
      : window.BbZapiet.resolve(
        matches,
        card.dataset.bbCrossLocationId,
        card.dataset.bbCrossCollectionTitle,
        false,
      );
    if (!location) return false;
    return Boolean(await window.BbZapiet.firstPickupDay(shop, location.id, [tree, cross]));
  };

  const update = (form) => {
    const card = form?.querySelector('[data-bb-cross-upsell]');
    if (!card) return;
    const treeId = form.querySelector('input[name="id"]')?.value;
    const match = [...card.querySelectorAll('[data-bb-cross-variant]')]
      .find((entry) => entry.dataset.treeId === treeId);
    const checkbox = card.querySelector('[data-bb-cross-checkbox]');
    const pickup = card.dataset.bbCrossPickup === 'true';
    const hasLocation = pickupLocation || card.dataset.bbCrossLocationId || card.dataset.bbCrossCollectionTitle;
    const request = String(Number(card.dataset.bbCrossRequest || 0) + 1);
    card.dataset.bbCrossRequest = request;
    card.dataset.bbCrossVerifiedId = '';
    checkbox.checked = false;
    checkbox.disabled = !match || match.dataset.crossAvailable !== 'true' || pickup;
    card.hidden = !match;
    card.querySelector('[data-bb-cross-price]').textContent = match ? `+ ${match.dataset.crossPrice}` : '';
    card.querySelector('[data-bb-cross-detail]').textContent = match
      ? `${match.dataset.crossSize} · ${card.querySelector(match.dataset.crossAvailable !== 'true' ? '[data-bb-cross-unavailable-text]' : pickup ? hasLocation ? '[data-bb-cross-checking-text]' : '[data-bb-cross-location-text]' : '[data-bb-cross-available-text]').textContent}`
      : '';
    if (!match || match.dataset.crossAvailable !== 'true' || !pickup || !hasLocation) return;
    eligibleAtPickup(card, match).then((eligible) => {
      if (!card.isConnected || card.dataset.bbCrossRequest !== request) return;
      checkbox.disabled = !eligible;
      card.dataset.bbCrossVerifiedId = eligible ? treeId : '';
      card.querySelector('[data-bb-cross-detail]').textContent = `${match.dataset.crossSize} · ${card.querySelector(eligible ? '[data-bb-cross-available-text]' : '[data-bb-cross-rejected-text]').textContent}`;
    }).catch(() => {
      if (!card.isConnected || card.dataset.bbCrossRequest !== request) return;
      card.querySelector('[data-bb-cross-detail]').textContent = `${match.dataset.crossSize} · ${card.querySelector('[data-bb-cross-rejected-text]').textContent}`;
    });
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('product-form input[name="id"]')) update(event.target.closest('form'));
  });

  document.addEventListener('product-info:loaded', (event) => {
    event.target.querySelectorAll('product-form form').forEach(update);
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('product-form form')) return;
    const card = form.querySelector('[data-bb-cross-upsell]');
    const checkbox = card?.querySelector('[data-bb-cross-checkbox]');
    if (!checkbox?.checked || checkbox.disabled) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.bbCrossSubmitting === 'true') return;

    const formData = new FormData(form);
    const treeId = Number(formData.get('id'));
    const match = [...card.querySelectorAll('[data-bb-cross-variant]')]
      .find((entry) => Number(entry.dataset.treeId) === treeId);
    if (!match || match.dataset.crossAvailable !== 'true') {
      update(form);
      return;
    }

    const quantity = Math.max(1, Number(formData.get('quantity')) || 1);
    const properties = {};
    for (const [key, value] of formData.entries()) {
      if (key.startsWith('properties[') && key.endsWith(']')) properties[key.slice(11, -1)] = value;
    }
    const tree = { id: treeId, quantity };
    if (Object.keys(properties).length) tree.properties = properties;
    const sellingPlan = formData.get('selling_plan');
    if (sellingPlan) tree.selling_plan = sellingPlan;

    const productForm = form.closest('product-form');
    const button = form.querySelector('[type="submit"]');
    form.dataset.bbCrossSubmitting = 'true';
    button?.setAttribute('aria-disabled', 'true');
    productForm?.handleErrorMessage();

    try {
      if (card.dataset.bbCrossPickup === 'true' && !(await eligibleAtPickup(card, match))) {
        update(form);
        throw new Error(card.querySelector('[data-bb-cross-rejected-text]').textContent);
      }
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [
          tree,
          {
            id: Number(match.dataset.crossId),
            quantity,
            properties: { _addon: 'kruis', _anchor_sku: match.dataset.treeSku },
          },
        ] }),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message);
      window.location.assign(window.routes.cart_url);
    } catch (error) {
      productForm?.handleErrorMessage(`${card.dataset.addError}${error.message ? ` (${error.message})` : ''}`);
      button?.removeAttribute('aria-disabled');
      delete form.dataset.bbCrossSubmitting;
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('product-form form').forEach(update), { once: true });
  } else {
    document.querySelectorAll('product-form form').forEach(update);
  }
})();
